import React, { useEffect, useState } from 'react';
import { colors, noteHeight, noteWidth } from '../util/notes.mjs';

const BoardEdges = function({boardRef, notes, zoom, pan, onReveal}) {
  const [view, setView] = useState(null);

  useEffect(() => {
    const board = boardRef.current;

    const measure = function() {
      const bounds = board.getBoundingClientRect();

      setView({
        left: bounds.left,
        top: bounds.top,
        width: board.clientWidth,
        height: board.clientHeight
      });
    };

    const observer = new ResizeObserver(measure);

    observer.observe(board);
    window.addEventListener('resize', measure);
    measure();

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', measure);
    };
  }, [boardRef]);

  if (!view?.width || !view.height) return null;

  const margin = 10;
  const centerX = view.width / 2;
  const centerY = view.height / 2;
  const halfWidth = Math.max(1, centerX - margin);
  const halfHeight = Math.max(1, centerY - margin);

  return <div
    className='boardEdges'
    style={{
      left: view.left,
      top: view.top,
      width: view.width,
      height: view.height
    }}
  >
    {notes.map(note => {
      const x = note.x * zoom + pan.x;
      const y = note.y * zoom + pan.y;
      const width = noteWidth(note) * zoom;
      const height = noteHeight(note) * zoom;

      if (x + width > 0 && x < view.width && y + height > 0 && y < view.height) return null;

      // Project a ray from the viewport center through the item center onto its edge.
      const dx = x + width / 2 - centerX;
      const dy = y + height / 2 - centerY;
      const scale = 1 / Math.max(Math.abs(dx) / halfWidth, Math.abs(dy) / halfHeight);
      const left = centerX + dx * scale;
      const top = centerY + dy * scale;
      const isImage = note.kind === 'image';
      const color = colors.find(item => item.id === note.color) || colors[0];
      const label = `show ${isImage ? 'image' : 'note'}: ${note.title || (isImage ? note.images[0]?.name : note.text?.slice(0, 60)) || 'untitled'}`;

      return <button
        key={note.id}
        className={`boardEdgeBox ${isImage ? 'isImage' : ''}`}
        style={{
          left,
          top,
          backgroundColor: isImage ? 'var(--surface)' : `var(--note-${color.id}, ${color.value})`
        }}
        aria-label={label}
        title={label}
        onClick={() => onReveal(note)}
      >
        {isImage && note.images[0] && <img src={note.images[0].src} alt='' draggable={false} />}
      </button>;
    })}
  </div>;
};

export default BoardEdges;
